/*
 * @Date: 2023-03-13 13:45:55
 * @LastEditTime: 2025-02-17 14:45:31
 * @FilePath: \cn_dictionary\src\constants\index.js
 * @Description:
 */
// 请求地址
// const baseUrl = 'http://172.18.70.102:8091'
// const baseUrl = 'http://82.156.249.11:8091'

// 官网
const baseUrl = 'https://api.zgcsxh.org.cn'
export default {
  baseUrl
}
